export class StringTransformer {
  constructor(private label: string) {}

  capitalizeFirstLetter(): this {
    const match = this.label.match(/^(.+?)(\s*\(.*\))?$/);

    if (!match) return this;

    const [_, main, suffix = ""] = match;

    this.label =
      main.charAt(0).toUpperCase() +
      main.slice(1).toLowerCase() +
      suffix;

    return this;
  }

  stripLabelSuffix(): this {
    this.label = this.label
      .replace(/\s*\(.*?\)/g, "")
      .trim();
    return this;
  }

  stripUnitSuffix(): this {
    this.label = this.label
      .replace(/\s*(\(milligram\)|\(intravenous\))/gi, "")
      .trim();
    return this;
  }

  toUpperCase(): this {
    this.label = this.label.toUpperCase();
    return this;
  }

  valueOf(): string {
    return this.label;
  }

  toString(): string {
    return this.label;
  }
}

export const transform = (label: string) =>
  new StringTransformer(label);
